module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/KnifeAndFork1-e943af3ba6dbf6a3cf8317c7435e7bf6.svg";